/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendActualLeasingContractDto } from '../../models/backend-actual-leasing-contract-dto';
import { BackendPatchedActualLeasingContractRequestDto } from '../../models/backend-patched-actual-leasing-contract-request-dto';

export interface MonitoringActualsLeasingsPartialUpdate$FormData$Params {
  id: number;
  body?: BackendPatchedActualLeasingContractRequestDto;
}

export function monitoringActualsLeasingsPartialUpdate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: MonitoringActualsLeasingsPartialUpdate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendActualLeasingContractDto>> {
  const rb = new RequestBuilder(rootUrl, monitoringActualsLeasingsPartialUpdate$FormData.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendActualLeasingContractDto>;
    }),
  );
}

monitoringActualsLeasingsPartialUpdate$FormData.PATH = '/api/monitoring/actuals/leasings/{id}/';
